import React, { useState, useEffect } from 'react';

const NotificationPanel = () => {
  const [notification, setNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    fetchNotification();
  }, []);

  const fetchNotification = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/notification`);
      if (response.ok) {
        const data = await response.json();
        if (data.active) {
          setNotification(data);
          setIsVisible(true);
        }
      }
    } catch (error) {
      console.error('Error fetching notification:', error);
    }
  };

  const handleDismiss = () => {
    setIsVisible(false);
    // Store dismissal in localStorage to prevent showing again for this session
    if (notification?.sourceId || notification?.id) {
      const dismissKey = notification.sourceId || notification.id;
      localStorage.setItem(`notification_dismissed_${dismissKey}`, 'true');
    }
  };

  // Check if notification was already dismissed
  useEffect(() => {
    if (notification) {
      const dismissKey = notification.sourceId || notification.id;
      const dismissed = localStorage.getItem(`notification_dismissed_${dismissKey}`);
      if (dismissed === 'true') {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    }
  }, [notification]);

  if (!isVisible || !notification) {
    return null;
  }

  const getNotificationStyle = () => {
    const baseStyle = {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      padding: '1rem',
      textAlign: 'center',
      fontSize: '0.875rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1rem'
    };

    switch (notification.type) {
      case 'maintenance':
        return { ...baseStyle, backgroundColor: '#ff9800', color: 'white' };
      case 'upgrade':
        return { ...baseStyle, backgroundColor: '#4caf50', color: 'white' };
      case 'warning':
        return { ...baseStyle, backgroundColor: '#f44336', color: 'white' };
      case 'info':
      default:
        return { ...baseStyle, backgroundColor: '#2196f3', color: 'white' };
    }
  };

  const getIcon = () => {
    switch (notification.type) {
      case 'maintenance':
        return '🔧';
      case 'upgrade':
        return '🚀';
      case 'warning':
        return '⚠️';
      case 'info':
      default:
        return 'ℹ️';
    }
  };

  return (
    <div style={getNotificationStyle()}>
      <span>{getIcon()}</span>
      <span style={{ flex: 1 }}>{notification.message}</span>
      {notification.dismissible !== false && (
        <button
          onClick={handleDismiss}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: '1.2rem',
            cursor: 'pointer',
            padding: '0 0.5rem',
            marginLeft: 'auto'
          }}
          title="Dismiss notification"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default NotificationPanel;